export {
  clientsMergeApi,
  useCheckClientForDuplicateMutation,
  useMergeClientsAtSameBranchMutation,
} from './api';
export {
  ClientsMergeEndpoints,
  type CheckClientForDuplicateRequest,
  type CheckClientForDuplicateResponse,
  type MergeClientsAtSameBranchRequest,
  type MergeClientsAtSameBranchResponse,
  type ModelClientCheck,
  type ModelClientCheckResult,
  type ModelClientLeadInfo,
  type ModelClientsForMerge,
} from './types';
